import {
  newImport,
  TakePhoto,
  pxToRem,
  getParamsByName,
  getAge
} from './common.js'
import UserAgent from './user-agent.js'
import Validate from './validate.js'
import Num from './num.js'
import Formatter from './formatter.js'
import Calendar from './calendar.js'
import Color from './color.js'

export {
  newImport,
  TakePhoto,
  pxToRem,
  getParamsByName,
  getAge,
  UserAgent,
  Validate,
  Num,
  Formatter,
  Calendar,
  Color
}



// WEBPACK FOOTER //
// ./src/utils/index.js